import { mapGetters, mapActions } from 'vuex'
import { TOOLBAR_SAY } from '@/config/contant'
import { getTextLength } from '@/utils'

export default {
  data() {
    return {
      replyObj: {
        id: 0,
        name: '',
      },
      message: '',
      placeholder: '请输入内容(限50字以内)',
      pageIndex: 1,
      pageCount: 20,
      showInput: false,
      clearable: false,
    }
  },
  computed: {
    ...mapGetters([
      'getToken',
      'isShowSay',
      'getVideoId',
      'getComments',
      'hasSayMore',
      'getCurrentSceneId',
      'getFetchSayStatus',
    ]),
    isShowInput() {
      return this.showInput
    },
  },
  methods: {
    ...mapActions({
      addSay: 'ADD_SAY',
      fetchSay: 'SAY_LIST',
      hasToken: 'HAS_TOKEN',
      getUserInfo: 'GET_USER_INFO',
      toggleLogin: 'TOGGLE_LOGIN',
      fetchReply: 'FETCH_REPLY',
      toggleReply: 'TOGGLE_REPLY',
      toggleSubReply: 'TOGGLE_SUB_REPLY',
      toggleVisible: 'TOGGLE_VISIBLE_TYPE',
    }),
    showMore(id, index) {
      this.fetchReply({ id, index })
    },
    showSubMore(gIdx, cIdx) {
      this.toggleSubReply({ gIdx, cIdx })
    },
    // 下拉
    handlePullDown() {
      this.loadMore()
      setTimeout(() => {
        this.pullDownRefresh = false
        this.$refs.scrollHook.scroll.finishPullDown()
      }, 1000)
    },
    // 上滑
    handlePullUp() {
      this.loadMore()
      setTimeout(() => {
        this.pullUpLoad = false
        this.$refs.scrollHook.scroll.finishPullUp()
      }, 1000)
    },
    handleReply(id, name) {
      this.replyObj.id = id
      this.replyObj.name = name
      this.showSayInput()
    },
    handleScroll() {
      // console.log('onscroll')
      // this.$refs.scrollHook
    },
    loadMore() {
      if (this.hasSayMore) {
        this.pageIndex++
        this.fetchSay({
          videoId: this.getVideoId,
          pageIndex: this.pageIndex,
          pageCount: this.pageCount,
        })
      }
    },
    async submitComment() {
      const userToken = await this.hasToken()

      if (!userToken) {
        this.$vgo.tip('请先登录', 'warning')
        setTimeout(() => {
          this.toggleLogin()
          this.close()
        }, 1000)
        return
      }

      if (!this.message || this.message === '') {
        this.$vgo.tip('随便写些什么吧！^~^', 'fail')
        return
      }
      // 限制100个字符 中文50个字
      if (getTextLength(this.message) > 100) {
        this.$vgo.tip('说说字数不能超过50个', 'fail')
        return
      }

      let formData = {
        fk_video_id: this.getVideoId,
        scene_id: this.getCurrentSceneId,
        content: this.message,
        token: userToken,
        hastotalreplays: true,
      }
      if (this.replyObj.id) {
        formData = Object.assign({}, formData, {
          id: this.replyObj.id,
          parent_id: 0,
        })
      } else {
        formData = Object.assign({}, formData, {
          fk_video_id: this.getVideoId,
          scene_id: this.getCurrentSceneId,
        })
      }
      await this.addSay(formData)
      window.$VM.$vgo.tip('评论成功!', 'success')

      this.reset()
    },
    showSayInput() {
      this.showInput = true
    },
    hideSayInput() {
      this.showInput = false
    },
    close() {
      this.toggleVisible(TOOLBAR_SAY)
      this.reset()
    },
    clearInput() {
      this.message = ''
      this.clearable = false
    },
    clearReply() {
      this.replyObj = {
        id: 0,
        name: '',
      }
    },
    reset() {
      this.clearReply()
      this.clearInput()
    },
  },
}
